<nz-spin [nzSpinning]="isButtonLoading">
<div class="space-y-3">
  <div class="flex items-center justify-between">
    <h5>{{ fieldLabelKey | transloco }}</h5>
    <ng-container *ngIf="this.language.name !== 'English'">
      <button class="ai-button flex items-center" nz-button nzType="default"
              [disabled]="this.editedTitle === ''"
              (click)="translateHotelDescription(this.editedTitle)">
        <span nz-icon nzType="plus"></span>
        {{ 'itineraries.addEditRemarksTitle.actions.translate' | transloco }}
      </button>
    </ng-container>
  </div>
  <div class="grid grid-cols-1 gap-6">
      <nz-form-item class="flex">
        <nz-form-control>
          <input
            type="text"
            nz-input
            class="w-full"
            [(ngModel)]="this.editedTitle"
            [placeholder]="placeholderKey | transloco"/>
        </nz-form-control>
      </nz-form-item>
  </div>
</div>
<div *nzModalFooter>
  <button nz-button nzType="default" (click)="handleCancel()">{{ 'itineraries.addEditRemarksTitle.actions.close' | transloco }}</button>
  <button nz-button nzType="primary" (click)="editRemarksTitle()" [disabled]="this.editedTitle ===''">{{ 'itineraries.addEditRemarksTitle.actions.edit' | transloco }}</button>
</div>
</nz-spin>
